import React, { Component } from 'react';
import { CookiesProvider } from 'react-cookie';
import Header from '../../../Components/V2/Header';
import FeaturedNews from '../../../Containers/V2/FeaturedNews';
import ListPlatForm from '../../../Containers/V2/ListPlatForm';
import LastestNews from '../../../Containers/V2/LastestNews';
import GroupPlatform from '../../../Containers/V2/GroupPlatform';
// import Multimedia from '../../../Containers/V2/Multimedia';
// import Intro from '../../../Containers/V2/Intro';
import OldNews from '../../../Containers/V2/OldNews';
import Footer from '../../../Components/V2/Footer';
import Logos from '../../../Containers/Logos';
import TopBanner from '../../../Components/Ads/TopBanner';
import './style.scss';
export default class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.hasPatch = false;
  }

  render() {
    return (
      <CookiesProvider>
        <div className='home-page background12'>
          <Header />
          {/* <Intro /> */}
          <main className='position-relative background12 mt-50'>
            <TopBanner />
            <FeaturedNews />
            <ListPlatForm />
            <div className='pt-50 pb-50 background-white'>
              <LastestNews />
              <GroupPlatform />
            </div>
            {/* <Multimedia /> */}
            <OldNews />
            <Logos />
          </main>
          <Footer />
        </div>
      </CookiesProvider>
    );
  }
}
